import logo from "../../assets/ExamWarriorLogo.svg";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";

function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/contact-us/subscribe`, { email });
      if (res.data.success) {
        setStatus("Subscription successful! Please check your inbox.");
        setEmail("");
      } else {
        setStatus("Something went wrong. Try again later.");
      }
    } catch (err) {
      console.error(err);
      setStatus("Error occurred. Try again later.");
    }
  };

  return (
    <footer className="bg-teal-50 px-4 sm:px-6 md:px-12 py-8">
      <div className="container px-2 sm:px-5 pb-2 mx-auto">
        <div className="flex flex-col sm:flex-row gap-8 sm:gap-4">
          {/* Logo Section */}
          <div className="w-full sm:w-1/5 flex justify-center sm:justify-start">
            <img
              src={logo}
              alt="Logo"
              className="h-24 w-24 sm:h-28 sm:w-28 md:h-32 md:w-32"
            />
          </div>

          {/* Navigation Links */}
          <div className="w-full sm:w-2/3 mt-1">
            <div className="grid grid-cols-2 sm:flex flex-wrap justify-center gap-2 sm:gap-x-4 md:gap-x-6 mx-auto">
              <Link className="text-gray-600 hover:text-gray-800 font-medium text-sm sm:text-base sm:font-semibold" to="/landing">
                Home
              </Link>
              <Link className="text-gray-600 hover:text-gray-800 font-medium text-sm sm:text-base sm:font-semibold" to="/oc-journey">
                OC Journey
              </Link>
              <Link className="text-gray-600 hover:text-gray-800 font-medium text-sm sm:text-base sm:font-semibold" to="/selective-journey">
                Selective Journey
              </Link>
              <Link className="text-gray-600 hover:text-gray-800 font-medium text-sm sm:text-base sm:font-semibold" to="/what-we-do">
                What we do
              </Link>
              <Link className="text-gray-600 hover:text-gray-800 font-medium text-sm sm:text-base sm:font-semibold" to="/faqs">
                Have Questions
              </Link>
              <Link className="text-gray-600 hover:text-gray-800 font-medium text-sm sm:text-base sm:font-semibold" to="/contact-us">
                Get in Touch
              </Link>
            </div>
          </div>

          {/* Newsletter Section */}
          <div className="w-full sm:w-1/3 px-0 sm:px-2">
            <h2 className="font-bold text-gray-900 text-base sm:text-lg mb-2 sm:mb-1">
              Expert Exam Tips in Your Inbox
            </h2>
            <p className="leading-6 text-sm sm:text-md text-gray-700 font-medium sm:font-semibold my-2 sm:my-1">
              Stay ahead in your OC/Selective journey! Subscribe to receive expert strategies, learning tips, and updates from ExamWarriors—designed to help your child succeed.
            </p>

            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-start justify-start gap-2 mt-4">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full sm:w-48 px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-yellow-400"
              />
              <button
                type="submit"
                className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-4 sm:px-6 py-2 rounded"
              >
                Subscribe
              </button>
            </form>

            {status && <p className="text-sm text-green-600 mt-2">{status}</p>}
          </div>
        </div>

        {/* Legal Links at Bottom Center */}
        <div className="border-t pt-3 flex justify-center gap-4 mt-8">
          <Link
            to="/terms&condition"
            className="text-gray-600 hover:text-blue-700 transition-colors duration-300 text-sm sm:text-base font-medium"
          >
            Terms & Conditions
          </Link>
          <span className="text-gray-400">|</span>
          <Link
            to="/privacy-policy"
            className="text-gray-600 hover:text-blue-700 transition-colors duration-300 text-sm sm:text-base font-medium"
          >
            Privacy Policy
          </Link>
        </div>


      </div>
    </footer>
  );
}

export default Footer;
